import { CLASS_GENDERS, DAYS_OF_WEEK } from "./classUtils";

// SelectInput translates `name` when choices are not from a reference.
export const dayChoices = DAYS_OF_WEEK.map((day) => ({
  id: day,
  name: `resources.classes.days.${day}`,
}));

export const genderChoices = CLASS_GENDERS.map((gender) => ({
  id: gender,
  name: `resources.classes.genders.${gender}`,
}));
